import { CharityVettingStatus } from 'api/users/types';
import useCharityVettingStatus from 'common/auth/useCharityVettingStatus';
import { Navigate, Outlet } from 'react-router';
import { CHARITY_VETTING_PATH, VETTING_PROGRESS_PATH } from 'src/core/paths/paths';

const RequireVetted = () => {
  const { isLoading, hasNoCharity, charityVettingStatus } = useCharityVettingStatus();

  if (isLoading) {
    return null;
  }
  // No charity yet → start the wizard. Any charity that isn't fully vetted
  // (in progress or refused) belongs on the progress page; sending an
  // in-progress charity into the flow instead made a submitted one visibly
  // bounce flow → progress on every root visit. The progress guard sends a
  // still-draft charity back to the flow from there.
  if (hasNoCharity) {
    return <Navigate to={CHARITY_VETTING_PATH} replace />;
  }
  if (charityVettingStatus !== CharityVettingStatus.Vetted) {
    return <Navigate to={VETTING_PROGRESS_PATH} replace />;
  }
  return <Outlet />;
};

export default RequireVetted;
